import _ from "lodash";
import InterviewsService from "@/services/InterviewsService";
import controls from "@/components/questions/Controls";
import questionMove from "@/components/questions/QuestionMove";
import questionType from "@/components/questions/QuestionType";

export default {
  props: ["question", "canEdit"],

  components: {
    controls,
    questionMove,
    questionType
  },

  data() {
    return {
      edit: false,
      mover: false,
      typer: false,
      loading: false,
      data: {},
      errors: {},
      images: [],
      weights: [
        { value: 5, label: "Very important" },
        { value: 4, label: "Important" },
        { value: 3, label: "Neutral" },
        { value: 2, label: "Unimportant" },
        { value: 1, label: "Ignore" }
      ],
      fieldWeights: [
        { value: 3, label: "High" },
        { value: 2, label: "Med" },
        { value: 1, label: "Low" }
      ],
      yesNo: [{ value: true, label: "Yes" }, { value: false, label: "No" }]
    };
  },

  computed: {
    routingMeta() {
      return {
        attributes: {
          value: {
            operators: ["=", ">", "<", "contains"]
          }
        }
      };
    }
  },

  methods: {
    showEdit() {
      this.edit = true;
      this.data = _.cloneDeep(this.question);

      if (!this.data.meta.hideNextButton) {
        this.data.meta.hideNextButton = false;
      }

      if (!this.data.routingRules) {
        this.data.routingRules = [];
      }

      if (this.question.kind === "location") {
        this.mergeLocations();
      }

      this.$store.dispatch("interview/addOpenEdit", this.question.id);
    },

    mergeLocations() {
      const locations = this.$store.getters["practice/locations"];
      const fields = [];
      _.forEach(locations, location => {
        const providers = [];
        const fieldLocation = _.filter(
          this.data.fields,
          l => l.location === location.location
        );
        const locationWeight = fieldLocation.length
          ? fieldLocation[0].weight
          : 2;

        _.forEach(location.providers, provider => {
          const fieldProviders = fieldLocation.length
            ? _.filter(fieldLocation[0].provider, p => p.name === provider.name)
            : {};
          const newProvider = { name: provider.name, weight: 2 };
          if (fieldProviders.length) {
            newProvider.weight = fieldProviders[0].weight;
          }
          providers.push(newProvider);
        });
        fields.push({
          location: location.location,
          weight: locationWeight,
          provider: providers
        });
      });

      this.data.fields = fields;
    },

    hideEdit() {
      this.edit = false;
      this.$store.dispatch("interview/removeOpenEdit", this.question.id);
    },

    remove() {
      InterviewsService.removeQuestion(
        this.question.id,
        this.question.interviewPageId
      );
    },

    showMove() {
      this.mover = true;
    },

    hideMove() {
      this.mover = false;
    },

    showTyper() {
      this.typer = true;
    },

    hideTyper() {
      this.typer = false;
    },

    onSubmit() {
      this.$store.dispatch("interview/removeOpenEdit", this.question.id);
      InterviewsService.updateQuestion(this.data).then(() => {
        this.edit = false;
        this.$parent.$forceUpdate();
      });
    }
  },

  created() {
    window.bus.$on("interview:edit:cancel", this.hideEdit);
  }
};
